var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7636 1.87999C11.4654 1.58181 10.949 1.78545 10.949 2.19999V4.73818C10.949 5.79999 11.8509 6.67999 12.949 6.67999C13.6399 6.68727 14.5999 6.68727 15.4218 6.68727C15.8363 6.68727 16.0545 6.19999 15.7636 5.90909C14.7163 4.85454 12.8399 2.95636 11.7636 1.87999Z",
    fill: "url(#paint0_linear_1363_6761)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1818 7.6839H13.08C11.3563 7.6839 9.9527 6.28027 9.9527 4.55663V2.45481C9.9527 2.05481 9.62543 1.72754 9.22543 1.72754H6.14179C3.90179 1.72754 2.09088 3.18208 2.09088 5.77845V12.2221C2.09088 14.8184 3.90179 16.273 6.14179 16.273H11.8582C14.0982 16.273 15.9091 14.8184 15.9091 12.2221V8.41117C15.9091 8.01117 15.5818 7.6839 15.1818 7.6839ZM8.63634 13.1821H5.72724C5.42906 13.1821 5.18179 12.9348 5.18179 12.6366C5.18179 12.3384 5.42906 12.0912 5.72724 12.0912H8.63634C8.93452 12.0912 9.18179 12.3384 9.18179 12.6366C9.18179 12.9348 8.93452 13.1821 8.63634 13.1821ZM10.0909 10.273H5.72724C5.42906 10.273 5.18179 10.0257 5.18179 9.72754C5.18179 9.42936 5.42906 9.18208 5.72724 9.18208H10.0909C10.3891 9.18208 10.6363 9.42936 10.6363 9.72754C10.6363 10.0257 10.3891 10.273 10.0909 10.273Z",
    fill: "url(#paint1_linear_1363_6761)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1363_6761",
    x1: 13.4229,
    y1: 1.73828,
    x2: 13.4229,
    y2: 6.68727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1363_6761",
    x1: 8.99997,
    y1: 1.72754,
    x2: 8.99997,
    y2: 16.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.7e87ed21127ac72bf4f0e0540e831de0.svg";
export { ForwardRef as ReactComponent };